import { Link } from "react-router-dom";
import { ArrowUpRight } from "../../../components/svgs";
import { convertHTMLStringToHTML } from "../../../utils/convertHTMLStringToHTML";
import { getReadingTime } from "../../../utils/readingTime";

const BlogFeatured = ({ blog }) => {
  if (!blog) return null;

  const url = blog?.slug ? `/blog/${blog.slug}` : `/blog/${blog?._id}`;
  const excerpt =
    blog?.content?.length > 170
      ? blog.content.slice(0, 170) + "..."
      : blog?.content;

  return (
    <section
      aria-label="Featured article"
      className=" grid grid-cols-1 md:grid-cols-2 mx-auto px-4 md:px-[26px] mt-[30px] md:mt-[50px] "
      style={{ maxWidth: "1280px", minHeight: "430px" }}
    >
      {" "}
      {/* IMAGE */}{" "}
      <Link
        to={url}
        className=" group relative block min-w-0 min-h-[300px] md:min-h-[430px] overflow-hidden rounded-tl-[18px] rounded-tr-[18px] md:rounded-tr-none md:rounded-tl-[22px] md:rounded-bl-[22px] "
        style={{ background: "#dde2ee" }}
      >
        {" "}
        <img
          src={blog?.contentHeaderImage}
          alt={blog?.title || "Featured article"}
          className=" absolute inset-0 w-full h-full object-cover transition-transform duration-[400ms] group-hover:scale-[1.025] "
        />{" "}
        <span
          aria-hidden="true"
          className="absolute inset-0"
          style={{
            background: "linear-gradient(to top, #060933ad, transparent 60%)",
          }}
        />{" "}
        <span
          aria-hidden="true"
          className="absolute text-primary bg-secondary"
          style={{
            zIndex: 1,
            bottom: "19px",
            left: "20px",
            letterSpacing: "0.06em",
            borderRadius: "999px",
            padding: "8px 11px",
            fontSize: "15px",
            fontWeight: 800,
          }}
        >
          {" "}
          EDITOR&apos;S PICK{" "}
        </span>{" "}
      </Link>{" "}
      {/* CONTENT */}{" "}
      <div
        className=" min-w-0 flex flex-col justify-center text-white rounded-bl-[18px] rounded-br-[18px] md:rounded-bl-none md:rounded-br-[22px] md:rounded-tr-[22px] px-[26px] py-[30px] md:px-[45px] md:py-[43px] "
        style={{ background: "var(--color-primary)" }}
      >
        {" "}
        {/* Category / Reading Time */}{" "}
        <div
          className="flex items-center"
          style={{
            gap: "10px",
            color: "#d9dcff",
            fontSize: "15px",
            fontWeight: 700,
          }}
        >
          {" "}
          <span>{blog?.category}</span>{" "}
          <i
            aria-hidden="true"
            className="bg-secondary rounded-full flex-none"
            style={{ width: "4px", height: "4px" }}
          />{" "}
          <span> {getReadingTime(blog?.content)} min read </span>{" "}
        </div>{" "}
        {/* Featured Story */}{" "}
        <p
          className="text-secondary"
          style={{
            letterSpacing: "0.1em",
            margin: "25px 0 9px",
            fontSize: "15px",
            fontWeight: 800,
          }}
        >
          {" "}
          FEATURED STORY{" "}
        </p>{" "}
        {/* Title */}{" "}
        <h2
          style={{
            letterSpacing: "-0.04em",
            margin: 0,
            fontFamily: "Georgia, serif",
            fontSize: "clamp(34px, 3.7vw, 51px)",
            fontWeight: 500,
            lineHeight: 1.08,
          }}
        >
          {" "}
          {blog?.title}{" "}
        </h2>{" "}
        {/* Excerpt */}{" "}
        <p
          style={{
            color: "#e7e8ff",
            margin: "20px 0 25px",
            fontSize: "16px",
            lineHeight: 1.65,
          }}
          dangerouslySetInnerHTML={convertHTMLStringToHTML(excerpt)}
        />{" "}
        {/* Read Story */}{" "}
        <Link
          to={url}
          className="inline-flex items-center w-fit text-white"
          style={{
            borderBottom: "2px solid var(--color-secondary)",
            gap: "9px",
            paddingBottom: "4px",
            fontSize: "15px",
            fontWeight: 800,
          }}
        >
          {" "}
          Read the featured story{" "}
          <ArrowUpRight className="w-3.5 h-3.5" fill="#fff" />{" "}
        </Link>{" "}
      </div>{" "}
    </section>
  );
};

export default BlogFeatured;
